import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauAnnulerAction from '../actions/BordereauAnnulerAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauForceEtatAcquittementAction from '../actions/BordereauForceEtatAcquittementAction';
import BordereauMettreEnEchecAction from '../actions/BordereauMettreEnEchecAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauTeletransmissionState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.TELETRANSMIS;
		this.state = BordereauStateType.TELETRANSMIS;
		this.color = '#9A5555';
		this.libelle = 'Télétransmission';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauDupliquerAction(),
			new BordereauAnnulerAction(),
			...(userRole === UserRole.ADMIN
				? [
						new BordereauModifierAction({ isSuperUser: true }),
						new BordereauMettreEnEchecAction({ isSuperUser: true }),
						new BordereauForceEtatAcquittementAction({
							isSuperUser: true,
							isAcquittement: true,
						}),
						new BordereauForceEtatAcquittementAction({
							isSuperUser: true,
							isAcquittement: false,
						}),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...this.getActionsAnnulationRejet(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauTeletransmissionState;
